import { ProgressIndicatorTypeTokens, } from '@voltmoney/schema';
export const args = {
    size: 1,
    activeIndex: 1,
    count: 0,
    type: ProgressIndicatorTypeTokens.default,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(ProgressIndicatorTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
